import { Modal } from 'react-bootstrap';
import { styled } from 'styled-components';
export const MainModalStyles = styled(Modal)`
  .loading__container {
    display: none;
    transition: all ease 250ms;
    height: 100%;
    width: 100%;
    position: fixed;
    inset: 0;
    justify-content: center;
    align-items: center;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.25);
    .loader {
      border: 5px solid #eaeaea;
      border-top: 5px solid #3498db;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      animation: spin 2s linear infinite;
    }
    .reload__button {
      font-size: 16px;
      font-weight: 500;
      color: #006b67;
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    &.loading {
      display: flex;
      .reload__button {
        display: none;
      }
    }
    &.error {
      display: flex;
      .loader {
        display: none;
      }
      .reload__button {
        display: block;
      }
    }
  }
  .modal-content {
    border-radius: 0px;
    .submit__button__container {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      > .submit__button {
        width: 100%;
        border: none;
        background-color: #006b67;
        color: white;
        padding: 8px 0;
        font-weight: 500;
        cursor: pointer;
        transition: all ease 250ms;
        &:hover {
          background-color: rgba(0, 107, 103, 0.8);
        }
      }
    }
  }
`;
